module.exports = __webpack_public_path__ + "1b22b190840952be2b4d91516401fafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard_tags.png
// module id = 61
// module chunks = 0 1 2 3 4